import script from "./BannerVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerVersion.vue?vue&type=script&setup=true&lang=ts"

import "./BannerVersion.vue?vue&type=style&index=0&id=1fdc4428&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdc4428"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QSpace});
